import { VertexType } from "./VertexType";

export class ImportVertexDTO{
    vertexSelected: VertexType[];
    isPublished: boolean;

}